import { webComponentWithJsonProp } from "../services/webComponentService";
import { ImageGalleryButtonsProps } from "../types/components/ImageGalleryButtonsProps";
import { ResponsiveImage } from "../types/components/ResponsiveImage";
import { Picture } from "./Picture.tsx";

function ImageGalleryButtons({ images, imageGalleryId }: ImageGalleryButtonsProps) {
	function onClick(image: ResponsiveImage) {
		const nodes = [...document.querySelectorAll(`[data-image-gallery="${imageGalleryId}"]`)];
		for (const node of nodes) {
			node.classList.add("hidden");
		}
		const selectedNode = nodes.find(
			(x) => x.querySelector("img")?.getAttribute("src") === image.urls[0]
		);
		if (!selectedNode) {
			return;
		}
		selectedNode.classList.remove("hidden");
	}

	return (
		<div className="grid grid-cols-4 gap-6" aria-orientation="horizontal" role="tablist">
			{images.map((image: ResponsiveImage, index: number) => (
				<button
					key={index}
					onClick={() => onClick(image)}
					className="relative flex h-24 cursor-pointer items-center justify-center rounded-md bg-white text-sm font-medium text-gray-900 uppercase hover:bg-gray-50 focus:ring focus:ring-indigo-500/50 focus:ring-offset-4 focus:outline-none"
					aria-controls="tabs-1-panel-1"
					role="tab"
					type="button"
				>
					<span className="absolute inset-0 overflow-hidden rounded-md">
						<Picture
							imageUrls={image.urls}
							altText={image.alt}
							imgClassName="size-full object-cover"
						/>
					</span>
					<span
						className="pointer-events-none absolute inset-0 rounded-md ring-2 ring-transparent ring-offset-2"
						aria-hidden="true"
					></span>
				</button>
			))}
		</div>
	);
}

export default webComponentWithJsonProp("image-gallery-buttons", ImageGalleryButtons);
